import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { hideLoader, showLoader } from '../../../api/loader/loaderSlice';
import { analyticsClient } from '../../../utils/axios';

export const fetchMisVat = async ({ queryKey }) => {
  const [, params] = queryKey;
  const { data } = await analyticsClient.get('/v1/mis/vat', { params, skipErrorSnackbar: true });
  return data;
};

export const useGetMisVatHandler = ({ queryParams = {}, enabled = true } = {}) => {
  const dispatch = useDispatch();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['mis-vat', queryParams],
    queryFn: async (context) => {
      dispatch(showLoader());
      try {
        return await fetchMisVat(context);
      } finally {
        dispatch(hideLoader());
      }
    },
    enabled,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    retry: 3,
  });

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        dispatch(
          showSnackbar({
            message: error.response?.data?.message || error.message,
            severity: 'error',
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: JSON.stringify(error),
            severity: 'error',
          }),
        );
      }
    }
  }, [dispatch, error, isError]);

  return {
    vatData: data,
    isLoading,
  };
};
